import { Component, inject } from '@angular/core';
import { HarvestActivityParameterService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  HarvestActivityParameterCreateDto,
  HarvestActivityParameterDto,
  HarvestActivityParameterExcelDownloadDto,
  HarvestActivityParameterUpdateDto,
} from '../proxy/controlling/dtos/harvest-activity-parameter';
import { HARVESTACTIVITYPARAMETER_CONFIG, HARVESTACTIVITYPARAMETER_FIELDS } from './harvest-activity-parameter.config';
import {  BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-harvest-activity-parameter',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, HarvestActivityParameterService, ConfirmationService],
  templateUrl: './harvest-activity-parameter.html',
  styleUrl: './harvest-activity-parameter.scss',
})
export class HarvestActivityParameter extends BaseHierarchicalCrudComponent<
  HarvestActivityParameterDto,
  HarvestActivityParameterCreateDto,
  HarvestActivityParameterUpdateDto,
  HarvestActivityParameterExcelDownloadDto
> {
  service = inject(HarvestActivityParameterService);
  config = HARVESTACTIVITYPARAMETER_CONFIG;
  fields = HARVESTACTIVITYPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: HarvestActivityParameterDto): HarvestActivityParameterUpdateDto {
    return {
      isProgrammedHour: data.isProgrammedHour,
      isWorkedHour: data.isWorkedHour,
      isDistributionHour: data.isDistributionHour,
      shouldCheckForOverlappingHour: data.shouldCheckForOverlappingHour,
      applyMaintenanceCheck: data.applyMaintenanceCheck,
      inStand: data.inStand,
      hasSample: data.hasSample,
      activityProcessParametrizationId: data.activityProcessParametrizationId,
      wbsId: data.wbsId,
      productivityHourId: data.productivityHourId,
      mobileCategoryId: data.mobileCategoryId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'HarvestActivityParameter';
  }
}
